import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { MiniStoreThemeContext } from "../../MiniStoreContexts/MiniStoreThemeContext";

const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  const { theme } = useContext(MiniStoreThemeContext);

  useEffect(() => {
    // console.log("GA INIT: gtag_primary_key =", theme?.gtag_primary_key);
    if (theme?.gtag_primary_key) {
      ReactGA.initialize(theme.gtag_primary_key, {
        gaOptions: { send_page_view: false },
      });
    }
  }, [theme?.gtag_primary_key]);

  useEffect(() => {
    console.log("Page View Sent to GA:", {
      page: location.pathname + location.search,
      gtag_primary_key: theme?.gtag_primary_key,
    });
    if (theme?.gtag_primary_key) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [location, theme?.gtag_primary_key]);

  return null;
};

export default GoogleAnalyticsTracker;
